export default __webpack_public_path__ + "static/media/Client-800X500.1074ca1b.png";